import React, {useState} from "react";
import styles from "./Associate.module.scss";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Create from "@material-ui/icons/Create";

export const AssociateList = ({
  props,
  associateList,
  deleteActionHandler,
}) => {
  return (
    <>
      {associateList.map((el, i) => (
        <div key={"loc-" + i} className={`${styles.editSection}`}>
          <>
            <div className={"row"}>
              <div className={"col-4"}>
                <label>Title</label>
              </div>
              <div className={"col-6 " + styles.divContent}>
                {el.title.label}
              </div>
              <div className={"col-2 " + styles.editButtonSection}>
                <Create
                  onClick={() => {
                    props.history.push(`./associate/detail/${i}`);
                  }}
                />
                <DeleteOutline
                  onClick={() => {
                    deleteActionHandler(i);
                  }}
                />
              </div>
            </div>
            {el.lastName && (
              <div className={"row"}>
                <div className={"col-4"}>
                  <label>Full Name</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                {el.firstName} {el.middleName} {el.lastName}
                </div>
              </div>
            )}
            {el.dayOfBirth && (
              <div className={"row"}>
                <div className={"col-4"}>
                  <label>Date of Birth</label>
                </div>
                <div className={"col-6 " + styles.divContent}>
                  {el.dayOfBirth}/{el.monthOfBirth}/{el.yearOfBirth}
                </div>
              </div>
            )}
            {el.dayTimePhoneNumber && (
              <div className={"row"}>
                <div className={"col-4"}>
                  <label>Daytime Telephone Number</label>
                </div>
                <div className={"col-6 " + styles.divContent}>
                  {el.dayTimePhoneNumber}
                </div>
              </div>
            )}
            {el.mobileNumber && (
              <div className={"row"}>
                <div className={"col-4"}>
                  <label>Mobile Number</label>
                </div>
                <div className={"col-6 " + styles.divContent}>
                  {el.mobileNumber}
                </div>
              </div>
            )}
            {el.email && (
              <div className={"row"}>
                <div className={"col-4"}>
                  <label>Email</label>
                </div>
                <div className={"col-6 " + styles.divContent}>{el.email}</div>
              </div>
            )}
          </>
        </div>
      ))}
    </>
  );
};

  
  export default AssociateList;